import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useOutletContext } from 'react-router-dom';
import { getRatingStatus, submitRating } from '../api/client';

export default function StarRating({ templateId, initialRating, ratingCount, onRatingChange }) {
  const { user, session } = useAuth();
  
  let setAuthOpen = null;
  try {
    const context = useOutletContext();
    setAuthOpen = context?.setAuthOpen;
  } catch (e) {}

  const [userRating, setUserRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [stats, setStats] = useState({ avg: initialRating || 0, count: ratingCount || 0 });

  useEffect(() => {
    if (!user || !session) return;
    
    // Fetch user's rating
    getRatingStatus(templateId)
      .then(data => {
        if (data.rating) setUserRating(data.rating);
      })
      .catch(console.error);
  }, [templateId, user, session]);

  const handleRate = async (score) => {
    if (!user) {
      if (setAuthOpen) setAuthOpen(true);
      else alert('Please log in to rate this template.');
      return;
    }

    setUserRating(score);

    try {
      const data = await submitRating(templateId, score);
      setStats({ avg: data.avg_rating, count: data.rating_count });
      if (onRatingChange) onRatingChange(data.avg_rating, data.rating_count);
    } catch (err) {
      console.error(err);
      alert('Failed to save rating');
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <div style={{ display: 'flex', gap: '2px' }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onMouseEnter={() => setHoverRating(star)}
            onMouseLeave={() => setHoverRating(0)}
            onClick={() => handleRate(star)}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '2px',
              color: (hoverRating || userRating) >= star ? '#f59e0b' : 'var(--text-tertiary)',
              transition: 'color 0.2s ease'
            }}
          >
            <Star size={24} fill={(hoverRating || userRating) >= star ? 'currentColor' : 'none'} />
          </button>
        ))}
      </div>
      <div style={{ color: 'var(--text-secondary)', fontSize: '14px', fontWeight: 500 }}>
        {stats.avg > 0 ? stats.avg.toFixed(1) : 'No ratings'} ({stats.count})
      </div>
    </div>
  );
}
